import React from 'react'
import { connect } from 'react-redux'
import { fetchPages, deserializePage } from 'supporticon/api/pages'
import { selectAPIParams } from '../../../store/site'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Loading from '../../ui/Loading'
import ProgressTiles from '../../ui/ProgressTiles'
import Section from '../../ui/Section'

class PageProgressTiles extends React.Component {
  constructor () {
    super()
    this.state = { pages: [], status: 'fetching' }
  }

  componentDidMount () {
    const { apiParams } = this.props

    fetchPages({ ...apiParams, allPages: true })
      .then(pages => pages.map(deserializePage))
      .then(pages => this.setState({ pages, status: 'fetched' }))
      .catch(error => {
        this.setState({ status: 'failed' })
        return Promise.reject(error)
      })
  }

  render () {
    const {
      action,
      alignment,
      backgroundImage,
      background,
      barColor,
      buttonBackground,
      buttonForeground,
      copy,
      copyAlignment,
      foreground,
      fundedAction,
      metric,
      size,
      spacing,
      subtitle,
      title,
      titleForeground,
      titleSize
    } = this.props

    const {
      pages,
      status
    } = this.state

    const data = pages.map((page) => {
      const isFunded = page.raised >= page.target
      const isDisabled = isFunded && fundedAction === 'disable'

      return {
        ...page,
        raised: page.raised / 100,
        target: page.target / 100,
        actions: [{
          to: action === 'view'
            ? isDisabled ? '' : page.url
            : isDisabled ? '' : page.donationUrl,
          label: action === 'view'
            ? isDisabled ? 'Project Funded' : 'View Project'
            : isDisabled ? 'Project Funded' : 'Donate Now'
        }]
      }
    })

    return (
      <Section
        alignment={alignment}
        backgroundImage={backgroundImage}
        background={background}
        foreground={foreground}
        size={size}
        spacing={spacing}>

        <Content
          copy={copy}
          copyAlignment={copyAlignment}
          subtitle={subtitle}
          title={title}
          titleForeground={titleForeground}>

          {status === 'fetching' && <Loading />}
          {status === 'failed' && <Error>There was an error loading pages.</Error>}
          {status === 'fetched' && (
            <ProgressTiles
              action={action}
              barColor={barColor}
              buttonBackground={buttonBackground}
              buttonForeground={buttonForeground}
              data={data}
              metric={metric}
              titleForeground={titleForeground}
              titleSize={titleSize}
            />
          )}

        </Content>
      </Section>
    )
  }
}

const mapState = (state) => ({
  ...selectAPIParams(state)
})

export default connect(mapState)(PageProgressTiles)



// WEBPACK FOOTER //
// ./components/slices/PageProgressTiles/index.js